export const initialDeliveryDays = ["deliveryDays_2 - Monday", "deliveryDays_3 - Tuesday", "deliveryDays_4 - Wednesday", "deliveryDays_5 - Thursday", "deliveryDays_6 - Friday", "deliveryDays_7 - Saturday", "deliveryDays_1 - Sunday"];

export const initialWeekDays = ["weekDays_2 - Monday", "weekDays_3 - Tuesday", "weekDays_4 - Wednesday", "weekDays_5 - Thursday", "weekDays_6 - Friday", "weekDays_7 - Saturday", "weekDays_1 - Sunday"];

export const commonBaseColumn = ['restaurants', ...initialWeekDays, ...initialDeliveryDays, 'arrivalTime', 'drTimeOpen', 'drTimeClose', 'drIsOpenedClosed', 'dtTimeOpen', 'dtTimeClose', 'dtIsOpenedClosed', 'deliveryTimeOpen', 'deliveryTimeClose', 'cateringTimeOpen', 'cateringTimeClose', 'curbsideTimeOpen', 'curbsideTimeClose', 'breakfastTimeOpen', 'breakfastTimeClose', 'lunchTimeOpen', 'lunchTimeClose', 'snackTimeOpen', 'snackTimeClose', 'dinnerTimeOpen', 'dinnerTimeClose', 'lateNightTimeOpen', 'lateNightTimeClose'];

export const commonDayColumn = ['restaurants', 'specialEventDateStart',
    'specialEventDateEnd', 'specialEventArrival', 'drTimeOpen', 'drTimeClose', 'drIsOpenedClosed', 'dtTimeOpen', 'dtTimeClose', 'dtIsOpenedClosed', 'deliveryTimeOpen', 'deliveryTimeClose', 'cateringTimeOpen', 'cateringTimeClose', 'curbsideTimeOpen', 'curbsideTimeClose', 'specialEventReason'];

function modifyTHColumn(columns, firstIndex, isSpecialEvent = false) {
    const departureKey = isSpecialEvent ? "specialEventDeparture" : "departureTime";
    columns.splice(firstIndex, 0, departureKey);
    return columns
}

export const BKBaseHeader = [...commonBaseColumn]

export const BKDayHeader = [...commonDayColumn]

export const PLKBaseHeader = [...commonBaseColumn]

export const PLKDayHeader = [...commonDayColumn]

export const THBaseHeader = modifyTHColumn([...commonBaseColumn], 16);

export const THDayHeader = modifyTHColumn([...commonDayColumn], 4, true);


export function getkeyValuePair(row, settingType, brand, langTranslations) {
    const setKeys = {
        drIsClosed: 'N',
        drIsOpened24Hours: 'N',
        dtIsClosed: 'N',
        dtIsOpened24Hours: 'N',
        isOnlyDeliveryDays: true
    }
    const getKeys = Object.keys(row);
    getKeys.forEach(key => {
        if (key.includes("IsOpenedClosed")) {
            setKeys['isOnlyDeliveryDays'] = false
            let getKey = key.substring(0, 2);
            const isClosed = getKey + "IsClosed";
            const IsOpened24Hours = getKey + "IsOpened24Hours";
            getKey = getKey === 'dh' ? 'delivery' : getKey;
            if (langTranslations[row[key]] === 'Closed') {
                setKeys[isClosed] = "Y";
                setKeys[IsOpened24Hours] = "N";
                if (settingType === 'Base') {
                    setKeys[getKey + 'TimeOpen'] = null;
                    setKeys[getKey + 'TimeClose'] = null;
                } else {
                    setKeys[getKey + 'TimeOpen'] = "";
                    setKeys[getKey + 'TimeClose'] = "";
                }

            } else if (langTranslations[row[key]] === '24 hours opened') {
                setKeys[isClosed] = "N";
                setKeys[IsOpened24Hours] = "Y";
                setKeys[getKey + 'TimeOpen'] = '00:00';
                setKeys[getKey + 'TimeClose'] = '23:59';
            } else {
                setKeys[isClosed] = "N";
                setKeys[IsOpened24Hours] = "N";
            }
            if (settingType === 'Base' && brand === 'BK' && getKey === 'delivery')
                delete setKeys['dhIsClosed']
        } else if (initialDeliveryDays.includes(key) && settingType === 'Base') {
            setKeys['selectedDeliveryDays'] = setKeys['selectedDeliveryDays'] ? [...setKeys['selectedDeliveryDays'], key] : [key]
            if (langTranslations[row[key]] === 'Yes') {
                const getValue = key.split("_")[1];
                if (setKeys['deliveryDays']) {
                    setKeys['deliveryDays'] = [...setKeys['deliveryDays'], getValue]
                } else {
                    setKeys['deliveryDays'] = [getValue]
                }
            }
        } else if (initialWeekDays.includes(key) && settingType === 'Base') {
            if (langTranslations[row[key]] === 'Yes') {
                setKeys['isOnlyDeliveryDays'] = false
                const getValue = key.split("_")[1]
                if (setKeys['weekDays']) {
                    setKeys['weekDays'] = [...setKeys['weekDays'], getValue]
                } else {
                    setKeys['weekDays'] = [getValue]
                }
            }
        } else if (settingType === 'Day' && ['specialEventDateStart', 'specialEventDateEnd'].includes(key)) {
            setKeys['isOnlyDeliveryDays'] = false
            setKeys['specialEventDateStart'] = row['specialEventDateStart'] || row['specialEventDateEnd'];
            setKeys['specialEventDateEnd'] = row['specialEventDateEnd'] || row['specialEventDateStart']
        } else if (settingType === 'Day' && key === 'specialEventReason') {
            if (row[key]) {
                setKeys['isOnlyDeliveryDays'] = false
                setKeys[key] = langTranslations[row[key]]
            }
        } else {
            if (row[key]) {
                setKeys['isOnlyDeliveryDays'] = false
                setKeys[key] = row[key] === '--' ? null : row[key];
            }
        }
    });
    return setKeys;
}

export const fileBrandLists = {
    'Burger King (Base Adjustment)': {
        brand: 'BK',
        setting: 'Base'
    },
    'Burger King (Day Adjustment)': {
        brand: 'BK',
        setting: 'Day'
    },
    'Tim Hortons (Day Adjustment)': {
        brand: 'TH',
        setting: 'Day'
    },
    'Tim Hortons (Base Adjustment)': {
        brand: 'TH',
        setting: 'Base'
    },
    'Popeyes (Day Adjustment)': {
        brand: 'PLK',
        setting: 'Day'
    },
    'Popeyes (Base Adjustment)': {
        brand: 'PLK',
        setting: 'Base'
    }
}
